import {  useEffect } from 'react';
import styles from './about.module.scss'


function About(props:any) {

  useEffect(() => {
   
    if(props.state.selected !=='about') {
      const clonedState = Object.assign({},props.state);
      clonedState.selected = 'about'
      props.stateChanger(clonedState);
  
    }


    return () => { }
  } );






    return (
      <div className={styles.container}>
        <iframe className = {styles.framecv}  title="Diego Burlando's Resume"   frameBorder="0" src="https://docs.google.com/document/d/1f6xOivRf5RCZK_VDiyFAN894RAt36f27SK4q82gLDeE/edit?usp=sharing"></iframe>
      </div>
    );
  }


  export default About;



